// Qualifying and Sprint Qualifying Top 3 results up to Round 13 (Hungary)
export const qualyResultsData = {
  "1": { // Australia
    "qualy": ["George Russell", "Kimi Antonelli", "Isack Hadjar"],
    "sprintQualy": null
  },
  "2": { // China
    "qualy": ["Kimi Antonelli", "George Russell", "Lewis Hamilton"],
    "sprintQualy": ["Kimi Antonelli", "George Russell", "Lewis Hamilton"]
  },
  "3": { // Japan
    "qualy": ["Kimi Antonelli", "George Russell", "Oscar Piastri"],
    "sprintQualy": null
  },
  "6": { // Miami
    "qualy": ["Kimi Antonelli", "Max Verstappen", "Charles Leclerc"],
    "sprintQualy": ["Lando Norris", "Kimi Antonelli", "Oscar Piastri"]
  },
  "7": { // Canada
    "qualy": ["George Russell", "Kimi Antonelli", "Lando Norris"],
    "sprintQualy": ["Max Verstappen", "Lewis Hamilton", "Kimi Antonelli"]
  },
  "8": { // Monaco
    "qualy": ["Kimi Antonelli", "Max Verstappen", "Lewis Hamilton"],
    "sprintQualy": null
  },
  "9": { // Spain
    "qualy": ["George Russell", "Lewis Hamilton", "Kimi Antonelli"],
    "sprintQualy": null
  },
  "10": { // Austria
    "qualy": ["George Russell", "Charles Leclerc", "Lewis Hamilton"],
    "sprintQualy": null
  },
  "11": { // Great Britain
    "qualy": ["Kimi Antonelli", "Charles Leclerc", "Lewis Hamilton"],
    "sprintQualy": ["Lewis Hamilton", "Kimi Antonelli", "Max Verstappen"]
  },
  "12": { // Belgium
    "qualy": ["Kimi Antonelli", "Max Verstappen", "George Russell"],
    "sprintQualy": null
  },
  "13": { // Hungary
    "qualy": ["Lando Norris", "Lewis Hamilton", "Charles Leclerc"],
    "sprintQualy": null
  }
,
  "14": {
    "qualy": ["Lando Norris", "George Russell", "Kimi Antonelli"],
    "sprintQualy": ["George Russell", "Lando Norris", "Charles Leclerc"]
  }
,
  "15": {
    "qualy": ["Pierre Gasly", "George Russell", "Oscar Piastri"],
    "sprintQualy": null
  }
,
  "16": {
    "qualy": ["Lando Norris", "Kimi Antonelli", "Max Verstappen"],
    "sprintQualy": null
  }
,
  "17": {
    "qualy": ["George Russell", "Charles Leclerc", "Oscar Piastri"],
    "sprintQualy": null
  }
};
